// ** React Imports
import { Fragment, useState, useEffect, useContext } from 'react'

// ** Third Party Components
import { Row, Col } from 'reactstrap'

// ** Calendar App Component Imports
import Calendar from './Calendar'

import useApi from '@hooks/useApi';
import { useRTL } from '@hooks/useRTL'
import useLoader from '@hooks/useLoader';
import { AuthContext } from '@context/AuthContext';

// ** Styles
import '@styles/react/apps/app-calendar.scss'

import { get_time_name } from "@utils"

const TimeSchedule = () => {

    const { userDetail } = useContext(AuthContext)

    const { isLoading, fetchData } = useLoader({})

    // ** states
    const [datas, setDatas] = useState([])

    // ** Hooks
    const [isRtl] = useRTL()

    // Api
    const scheduleApi = useApi().student.schedule

    async function getDatas() {
        const student_id = userDetail?.student?.id
        const { success, data } = await fetchData(scheduleApi.get(student_id))
        if(success) {
            if(data.length > 0) {
                for(var i in data) {
                    const times = get_time_name(data[i].time)
                    const odd_even = data[i]?.odd_even
                    var c_odd = ''
                    if (odd_even == 1) {
                        c_odd = 'Сондгой'
                    }
                    if (odd_even == 2) {
                        c_odd = 'Тэгш'
                    }
                    data[i].startTime = times.start_time
                    data[i].endTime = times.end_time
                    data[i].title = data[i]?.room?.code
                    ?
                        c_odd + ' ' + data[i]?.room?.code + ' тоот ' + ' ' +  data[i]?.lesson?.name + `(${data[i]?.type})`
                    :
                        c_odd + ' ' + data[i]?.lesson?.name + `(${data[i]?.type})`

                    data[i].daysOfWeek = [`${data[i].day === 7 ? 0 : data[i].day}`]

                    if (!data[i].color) {
                        data[i].color = '#eeeeee'
                        data[i].textColor = 'black'
                    }
                }
            }
            setDatas(data)
        }
    }

    useEffect(() => {
        getDatas()
    },[])

    return (
        <Fragment>
            <div className='app-calendar overflow-hidden border'>
                <Col className='position-relative'>
                    <Calendar
                        isRtl={isRtl}
                        eventDatas={datas}
                        isLoading={isLoading}
                    />
                </Col>
            </div>
        </Fragment>
    )
}

export default TimeSchedule
